/**
 * Scripts for the list page
 */
$(document).ready(function () {

    /**
     * Move inline edit form to end of body to allow absolute positioning over td being edited
     */
    $('#inline-field-form').appendTo($('body'));

    /**
     * Handle submit of inline edit form
     */
    $('#inline-field-form').submit(function () {
        clearSelection();
        $('#inline-overlay').hide();
        var target = $('#inline-overlay').data("editing");
        $(target).html("<span class='please-wait-saving badge badge-success'>Saving...</span>");

        $.post($(this).attr('action'), $(this).serialize(), function (result) {

            data = $.parseJSON(result);

            var target = $('#inline-overlay').data("editing");
            $(target).html(data.display);

            if (data.errors.length > 0)
            {
                var error_text = "";
                for (var i = 0 ; i < data.errors.length ; i++)
                {
                    error_text += data.errors[i].message + "\n";
                }

                swal({
                    title: "Unable to change item",
                    text: error_text,
                    type: "error"
                });
            }
        });
        return false;
    });

    /**
     * Toggle advanced filters visible or hidden
     */
    $('.js-filter-toggle-advanced').click(function (ev) {
        ev.preventDefault();

        $('.filter-advanced').toggle();

        if ($('#show_advanced').val() == 1) {
            $('#show_advanced').val(0);
        } else {
            $('#show_advanced').val(1);
        }
    });

    /**
     * Submit any changes to the filter
     */
    $('.js-filter-submit').click(function (ev) {
        ev.preventDefault();

        $('#list-filter').submit();
    })


    /**
     * Submit new preset
     */
    $('.js-filter-preset-save').click(function (ev) {
        ev.preventDefault();

        swal({
            title: "Save Preset",
            text: "Saving filters as preset. Please enter a name",
            type: "input",
            showCancelButton: true,
            closeOnConfirm: false,
            animation: "slide-from-top",
            inputPlaceholder: "Preset Name",
            confirmButtonColor: "#18a689",
            confirmButtonText: "Save",
            cancelButtonColor: "#ED5565",
            cancelButtonText: "Cancel",
        },
        function(inputValue){
            if (inputValue === false) return false;

            if (inputValue === "") {
                swal.showInputError("Please enter a preset name");
                return false
            }

            $('#filter_submit').val(2);
            $('#filter_preset_save_name').val(inputValue);
            $('#list-filter').submit();
        });
    });

    $('.js-filter-preset-manage').click(function (ev) {
        ev.preventDefault();

        $('#preset-manage-modal').modal();
    });

    $('.js-remove-preset').click(function (ev) {
        ev.preventDefault();

        $('#preset-manage-modal').modal("hide");

        var url = $(this).attr('href');

        swal({
            title: "Are you sure?",
            text: "You may not be able to recover this preset.",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes, delete it!",
            closeOnConfirm: true
        }, function () {
            window.location = url;
        });
    });

    /**
     * Allow enter on a search field to submit the filter
     */
    $('.js-filter-search').keypress(function (event) {
        if (event.which == 13) {
            event.preventDefault();
            $('#list-filter').submit();
        }
    });

    /**
     * Save new order button pressed
     */
    $('.js-ordering-save').click(function (ev) {
        ev.preventDefault();
        $('#ordering-form').submit();
    });

    /**
     * Cancel button on inline edit form
     */
    $('.js-inline-field-cancel').click(function (ev) {
        ev.preventDefault();
        $('#inline-overlay').hide();
    });

    /**
     * Save button on inline edit form
     */
    $('.js-inline-field-save').click(function (ev) {
        ev.preventDefault();
        $('#inline-field-form').submit();
    });

    /**
     * Submit multi row action
     */
    $('.js-action-select-button').click(function (ev) {
        ev.preventDefault();
        var action = $(this).data('action');
        var params = $(this).data('actionParams');
        if ($(this).hasClass("js-action-select-confirm-delete")) {
            swal({
                title: "Are you sure?",
                text: "You will not be able to recover these items.",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes, delete them!",
                closeOnConfirm: false
            }, function () {
                $('#action-form-action').val(action);
                $('#action-form').submit();
            });
        } else if ($(this).hasClass('dropdown-toggle')){
            //nothing to do, we don't want to submit the form at the first click
        } else {
            $('#action-form-action').val(action);
            $('#action-form-action-params').val(params);
            $('#action-form').submit();
        }
    });
});

/**
 * Allow this to be called from external places, such as triggering event setup when doing an inline list
 *
 * This will get called for the body of the page, and again for any subsequent reloads of an inline list or similar
 * @param prefix
 */
admin.registerLoad(function (prefix) {
    /**
     * Item with inline edit double clicked to trigger inline edit
     */
    $(prefix + '.js-inline-field').dblclick(function (ev) {
        ev.preventDefault();
        clearSelection();

        if ($(this).hasClass('type_checkbox') || $(this).hasClass('type_moderate')) {

            var $target = $(this);
            // if we have a checkbox, then we just need to toggle its value
            $target.html("<span class='please-wait-loading badge badge-success'>Saving...</span>");

            $.ajax({
                url: $target.data('inline-url'),
                dataType: 'json',
                success: function(data) {
                    $target.html(data.display);

                    if (data.errors.length > 0)
                    {
                        var error_text = "";
                        for (var i = 0 ; i < data.errors.length ; i++)
                        {
                            error_text += data.errors[i].message + "\n";
                        }

                        swal({
                            title: "Unable to change item",
                            text: error_text,
                            type: "error"
                        });
                    }
                }
            });

            return;
        }

        $('#inline-overlay').show();
        $('#inline-overlay').data("editing", this);
        $('#inline-overlay-edit').html("<span class='please-wait-loading badge badge-success'>Loading...</span>");
        $('#inline-overlay-edit').load($(this).data('inline-url'), function () {
            $(this).find("input[type='text']").first().focus();
            $(this).find("select").first().focus();
            admin.loaded('#inline-overlay');
        });
        $('#inline-overlay').css('left', $(this).offset().left + "px");
        $('#inline-overlay').css('top', $(this).offset().top + "px");
        $('#inline-overlay-edit').css('width', $(this).outerWidth() + "px");
        $('#inline-overlay-edit').css('min-height', ($(this).outerHeight() - 5) + "px");

        $('#inline-field-form').attr('action', $(this).data('inline-url'));
    });

    /**
     * Delete confirmation on single item
     **/
    $(prefix + '.js-confirm-delete').click(function (ev) {
        ev.preventDefault();

        var url = $(this).attr('href');

        swal({
            title: "Are you sure?",
            text: "You may not be able to recover this item.",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes, delete it!",
            closeOnConfirm: false
        }, function () {

            // do delete
            window.location = url;
        });
    });


    /**
     * Enable sorting on the list when ordered by a relevant column
     */
    $(prefix + ".js-orering-list").sortable({
        handle: ".handle",
        update: function (event, ui) {
            $('#js-ordering-popup').show();
            var orderNo = 1;
            $('.js-ordering-input').each(function () {
                $(this).val(orderNo++);
            });
        }
    });

    $(prefix + ".js-action-select-all").each(function () {
        var select = $(this);
        select.unbind("change");
        select.change(function () {
            if (select.prop('checked'))
            {
                $(prefix + ".js-action-select-row").prop('checked', true);
            } else {
                $(prefix + ".js-action-select-row").prop('checked', false);
            }
            action_select_update();
        })
    });

    $(prefix + ".js-action-select-row").each(function () {
        var select = $(this);
        select.unbind("change");
        select.change(function () {
            action_select_update();
        })
    });

    function action_select_update() {
        var enabled = false;

        $(prefix + ".js-action-select-row").each(function () {
            var select = $(this);
            if (select.prop('checked'))
            {
                enabled = true;
            }
        });

        if (enabled)
        {
            $('.js-action-select-button').removeClass('disabled');
        } else {
            $('.js-action-select-button').addClass('disabled');
        }
    }

    action_select_update();

    $(prefix + ".js-order-column").each(function () {
       // process all order headers, and add
        var el = $(this);
        var el_order = $(this).data('order-name');
        var order_select = $("select[name='order']");
        var cur_order_value = order_select.val();
        var cur_order = cur_order_value ? cur_order_value.split(".")[0] : "";
        var cur_order_dir = cur_order_value ? cur_order_value.split(".")[1] : "";

        el.click(function (ev) {
            ev.preventDefault();

            if (el_order == cur_order)
            {
                // need to change direction if possible
                var find = el_order + "." + (cur_order_dir == "desc" ? 'asc' : 'desc');
                if (order_select.find("option[value='" + find + "']").length > 0) {
                    order_select.val(find);
                    order_select.trigger("chosen:updated");
                    applyFilter();
                }
            } else {
                order_select.find("option").each(function () {
                    var value = $(this).attr("value");
                    if (value.split(".")[0] == el_order)
                    {
                        order_select.val(value);
                        order_select.trigger("chosen:updated");
                        applyFilter();

                        return false;
                    }
                })
            }
        });

        // check for current order and if it is same as this column

        if (el_order == cur_order)
        {
            if (cur_order_dir == "desc")
            {
                $(this).append("&nbsp;<i class='glyphicon glyphicon-sort-by-alphabet-alt'></i>");
            } else {
                $(this).append("&nbsp;<i class='glyphicon glyphicon-sort-by-alphabet'></i>");
            }
        }
    });
});

/**
 * Clear any text selection on the form when doing a double click edit
 */
function clearSelection() {
    if (window.getSelection) {
        window.getSelection().removeAllRanges();
    } else if (document.selection) {
        document.selection.empty();
    }
}

/**
 * Called to submit the filter form but selects on change events
 */
function applyFilter() {
    $('#list-filter').submit();
}